"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require("reactstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Obalovací třída pro kontextové menu.
 * Použití:
 * <ContextMenu>
 *   <DropdownItem></DropdownItem>
 * </ContextMenu>
 */
var ContextMenu = function (_React$Component) {
    (0, _inherits3.default)(ContextMenu, _React$Component);

    function ContextMenu() {
        (0, _classCallCheck3.default)(this, ContextMenu);
        return (0, _possibleConstructorReturn3.default)(this, (ContextMenu.__proto__ || (0, _getPrototypeOf2.default)(ContextMenu)).apply(this, arguments));
    }

    (0, _createClass3.default)(ContextMenu, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                _reactstrap.ButtonDropdown,
                { isOpen: true, toggle: function toggle() {}, className: "context-menu-container" },
                _react2.default.createElement(
                    _reactstrap.DropdownMenu,
                    null,
                    this.props.children
                )
            );
        }
    }]);
    return ContextMenu;
}(_react2.default.Component);

exports.default = ContextMenu;
;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvY29udGV4dC1tZW51L0NvbnRleHRNZW51LmpzeCJdLCJuYW1lcyI6WyJDb250ZXh0TWVudSIsInByb3BzIiwiY2hpbGRyZW4iLCJSZWFjdCIsIkNvbXBvbmVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBRUE7Ozs7Ozs7SUFPcUJBLFc7Ozs7Ozs7Ozs7aUNBQ1I7QUFDTCxtQkFDSTtBQUFDLDBDQUFEO0FBQUEsa0JBQWdCLFlBQWhCLEVBQXVCLFFBQVEsa0JBQUksQ0FBRSxDQUFyQyxFQUF1QyxXQUFVLHdCQUFqRDtBQUNJO0FBQUMsNENBQUQ7QUFBQTtBQUNLLHlCQUFLQyxLQUFMLENBQVdDO0FBRGhCO0FBREosYUFESjtBQU9IOzs7RUFUb0NDLGdCQUFNQyxTOztrQkFBMUJKLFc7QUFVcEIiLCJmaWxlIjoiQ29udGV4dE1lbnUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHtEcm9wZG93bk1lbnUsIEJ1dHRvbkRyb3Bkb3dufSBmcm9tIFwicmVhY3RzdHJhcFwiO1xuXG4vKipcbiAqIE9iYWxvdmFjw60gdMWZw61kYSBwcm8ga29udGV4dG92w6kgbWVudS5cbiAqIFBvdcW+aXTDrTpcbiAqIDxDb250ZXh0TWVudT5cbiAqICAgPERyb3Bkb3duSXRlbT48L0Ryb3Bkb3duSXRlbT5cbiAqIDwvQ29udGV4dE1lbnU+XG4gKi9cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIENvbnRleHRNZW51IGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50IHtcbiAgICByZW5kZXIoKSB7XG4gICAgICAgIHJldHVybiAoXG4gICAgICAgICAgICA8QnV0dG9uRHJvcGRvd24gaXNPcGVuIHRvZ2dsZT17KCk9Pnt9fSBjbGFzc05hbWU9XCJjb250ZXh0LW1lbnUtY29udGFpbmVyXCI+XG4gICAgICAgICAgICAgICAgPERyb3Bkb3duTWVudT5cbiAgICAgICAgICAgICAgICAgICAge3RoaXMucHJvcHMuY2hpbGRyZW59XG4gICAgICAgICAgICAgICAgPC9Ecm9wZG93bk1lbnU+XG4gICAgICAgICAgICA8L0J1dHRvbkRyb3Bkb3duPlxuICAgICAgICApO1xuICAgIH1cbn07XG4iXX0=